﻿export class SurveySearch {
    codeFilter: string;
    titleFilter: string;
    dateCreatedFrom: Date;
    dateCreatedTo: Date;
    typeIdFilter: number;
    categoryIdFilter: number;
    participantTypeIdFilter: number;
    statusIdFilter: number;
    languageID: number;
    pageNumber: number;
    pageSize: number;
    column: string;
    isDesc: boolean;
    //public modul
    dateValidFromFrom: Date;
    dateValidFromTo: Date;
    dateValidToFrom: Date;
    dateValidToTo: Date;
    //my surveys modul
    userId: number;
}